import React from 'react';
import {
    BrowserRouter,
    Routes,
    Route
} from 'react-router-dom';
import LoginPage from './components/LoginPage';
import CustomerPage from './components/CustomerPage';
import ProjectPage from './components/ProjectPage';
import PrivateRoute from './components/PrivateRoute';
import TimeEntryPage from './components/TimeEntryPage';
import Layout from './components/Layout';
import Settings from "./components/Settings";
import EmployeeArea from "./components/EmployeeArea";
import ProjectAcquisition from './components/ProjectAcquisition';
import CustomerContacts from "./components/CustomerContacts";
import KPI from "./components/KPI";

export default function App() {
    return (
        <BrowserRouter>
            <Routes>
                <Route path="/" element={<LoginPage/>}/>

                <Route path="/customers" element={
                    <PrivateRoute>
                        <Layout>
                            <CustomerPage/>
                        </Layout>
                    </PrivateRoute>
                }/>

                <Route path="/kpi" element={
                    <PrivateRoute>
                        <Layout>
                            <KPI/>
                        </Layout>
                    </PrivateRoute>
                }/>

                <Route path="/projects" element={
                    <PrivateRoute>
                        <Layout>
                            <ProjectPage/>
                        </Layout>
                    </PrivateRoute>
                }/>

                <Route path="/project_acquisition" element={
                    <PrivateRoute>
                        <Layout>
                            <ProjectAcquisition/>
                        </Layout>
                    </PrivateRoute>
                }/>
                <Route path="/customer_contacts" element={
                    <PrivateRoute>
                        <Layout>
                            <CustomerContacts/>
                        </Layout>
                    </PrivateRoute>
                }/>

                <Route path="/timeentries" element={
                    <PrivateRoute>
                        <Layout>
                            <TimeEntryPage/>
                        </Layout>
                    </PrivateRoute>
                }/>
                <Route path="/employee" element={
                    <PrivateRoute>
                        <Layout>
                            <EmployeeArea/>
                        </Layout>
                    </PrivateRoute>
                }/>

                <Route path="/settings" element={
                    <PrivateRoute>
                        <Layout>
                            <Settings/>
                        </Layout>
                    </PrivateRoute>
                }/>
            </Routes>
        </BrowserRouter>
    );
}
